import { cn } from "@/utils/classes";
import { classColors } from "@/utils/classification-mapping";
import { UniqueIdentifier } from "@dnd-kit/core";
import { PriorityColumn } from "../types/visual-hierarchy.types";

/* Prop Types */
interface VisualHierarchyItemProps {
  id: UniqueIdentifier;
  columnsState: PriorityColumn[];
  className?: string;
}

/*
 * VisualHierarchyItem component
 * A component that renders an item in the visual hierarchy.
 * It displays the item's label, classification color, and number of regions.
 */
export const VisualHierarchyItem = ({ id, columnsState, className }: VisualHierarchyItemProps) => {
  // Find the item in the columnsState
  const item = columnsState.flatMap((col: any) => col.items).find((item: any) => item.label === id);
  const classification = item?.classification;
  const regionLength = item?.numRegion;

  /* Render */
  return (
    <div className={cn("bg-base-100 border border-base-300 w-full p-4 my-2 rounded-lg flex items-center justify-between", className)}>
      <div className="flex items-center gap-6">
        <div className="size-4 rounded-xs inline-block" style={{ backgroundColor: classification ? classColors[classification] : undefined }} />
        <p className="text-sm">{id}</p>
      </div>
      <p className="text-sm opacity-50">{regionLength} assets</p>
    </div>
  );
};
